import { Model } from "@/models";
import { snakeToLowerCamel } from "@/utils/String";

export interface DepthSettings {
  depth: number;
  labels?: {
    depth: number;
    label: string;
  }[];
}

export interface AgentConfiguration {
  label: string;
  area: DepthSettings;
  coordinator: DepthSettings;
}

export default class AgentModuleConfiguration extends Model {
  static type = "clientsAgentModuleConfigurations";

  agentCompanyAgentConf!: { [key: string]: AgentConfiguration };
  agencyAgentConf!: AgentConfiguration;
  agentCompanyAgentTypes!: string[];

  getAgentCompanyAgentConfByType(agentType: string): AgentConfiguration | null {
    return this.agentCompanyAgentConf[snakeToLowerCamel(agentType)] || null;
  }
}
